import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this._initFromBsData()
  }

  select(event) {
    const target = event.currentTarget.dataset.tabTarget || event.currentTarget.dataset.bsTarget
    this._activate(target, event.currentTarget)
  }

  _activate(selector, clickedTab) {
    this.tabTargets.forEach(t => t.classList.remove('active'))
    this.panelTargets.forEach(p => {
      p.classList.remove('active', 'show')
      p.style.display = 'none'
    })

    if (clickedTab) clickedTab.classList.add('active')

    const panel = this.element.querySelector(selector)
    if (panel) {
      panel.classList.add('active', 'show')
      panel.style.display = 'block'
    }
  }

  _initFromBsData() {
    const bsTabs = this.element.querySelectorAll('[data-bs-toggle="tab"]')
    bsTabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault()
        const target = tab.dataset.bsTarget || tab.getAttribute('href')
        this._activate(target, tab)
      })
    })
  }
}
